import React, { useEffect, useRef, useState } from 'react'
import bannerimg from "../../assets/Purposeblue.png";
import plane from "../../assets/Plane2.png";
import blue_ring from "../../assets/Blue-Ring-cut.png";
import Playicon from "../../assets/playicon.png";
import provizionlogo from "../../assets/Provizion-bug.png";
import PurposeLogo from "../../assets/PurposeLogo.png";
import Kindle from "../../assets/Kindle.png";
import MstrKeys from "../../assets/MstrKeys.png";
import WilliamImge2 from "../../assets/william-background2.png";
import PowerlineForm from "../powerline/PowerlineForm";
import rebon from "../../assets/rebon.png";
import ring_gold from "../../assets/ring_gold.png";
import logo from "../../assets/logo.png"
import VideoPlayer from '../../Common/Components/VideoPlayer';
import mainplay from "../../assets/mainplay.png";
import Player from '@vimeo/player';
import purpose_coverup from "../../assets/purpose_coverup.jpg";
import NewHeader from '../Neweheader';
import kingnew from "../../assets/King.png";
import { useNavigate } from 'react-router-dom';
import { storeAssigned } from '../../services/Methods/normalMethods';
import footerlogo from '../../assets/footer-image.png';
import DestinyInstitue from '../../assets/theDestinyI.jpeg';
import VisitorList from '../../Common/Components/VisitorComponent';



const Purposee = () => {

    const videos = {
        Purpose: "https://player.vimeo.com/video/1057650843?autoplay=1&autopause=0&controls=true",
    };

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(null);

    const openPopup = (videoKey) => {
        setCurrentVideo(videos[videoKey]);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setCurrentVideo(null);
    };

    const iframeRef = useRef(null);
    const playerRef = useRef(null);

    useEffect(() => {
        if (isPopupOpen && iframeRef.current) {
            playerRef.current = new Player(iframeRef.current);
            playerRef.current.on('ended', () => setIsPopupOpen(false));
        }

        return () => {
            if (playerRef.current) playerRef.current.off('ended');
        };
    }, [isPopupOpen]);

    const navigate = useNavigate();


    return (
        <>
            <section className='bg-[#fff] relative'>
                <img className=' absolute top-0 left-0 w-full z-[1] xl:h-[1160px] lg:h-[960px] md:h-[730px] h-[630px] object-cover' src={bannerimg} alt="" />
                <div className='xl:h-[820px] lg:h-[720px] md:h-[600px] h-[520px] container max-w-[1380px] mx-auto px-[15px] relative z-[2]'>
                    <div className="wraper-div flex md:justify-between justify-center h-full flex-wrap">
                        <div className="left pt-[109px] relative lg:left-[150px] md:left-[50px] left-[15px] md:w-auto w-full">
                            <h2 className='font-osw text-[#5E5E5E] xl:text-[90px] xl:leading-[90px] lg:text-[80px] lg:leading-[80px] md:text-[70px] md:leading-[70px] text-[60px] leading-[60px]'>DESTINY</h2>
                            <h3 className='font-osw text-[#5E5E5E] xl:text-[60px] xl:leading-[90px] lg:text-[40px] lg:leading-[60px] text-[30px] leading-[40px] md:text-center mt-[0px]'>TRAINING</h3>

                        </div>
                        <div className="right max-w-[620px] mt-auto lg:pb-[250px] pb-[200px] relative md:right-[50px] right-[0px] md:w-auto w-full">
                            <h3 className='xl:text-[40px] xl:leading-[50px] lg:text-[30px] lg:leading-[40px] text-[20px] leading-[30px] text-[#5E5E5E] text-center font-semibold  '>
                                DISCOVER YOUR DESTINY <br />IT’S WHAT YOU WERE BORN FOR
                            </h3>
                        </div>
                    </div>
                </div>
            </section>

            <section className='bg-no-repeat bg-center bg-cover' style={{ backgroundImage: `url(${plane})`, backgroundPosition: "center top" }}>

                <div className='xl:h-[987px] lg:h-[800px] h-[500px] container max-w-[1380px] mx-auto px-[15px] relative'>
                    <div class="right-div md:max-w-[450px] max-w-[400px] w-full text-center absolute top-[180px] -translate-y-[50%]  md:translate-x-[unset] md:right-[15px] md:left-[auto] left-[50%] -translate-x-[50%] italic"><p class="text-[#5E5E5E] font-semibold lg:text-[30px] lg:leading-[36px] text-[22px] leading-[25px]">“Have a purpose that reaches beyond your neighborhood, that leaves a path for generations to follow.” </p><p class="font-semibold text-[#5E5E5E] text-[30px] leading-[30px] mt-[30px]">— Anonymous</p></div>

                </div>
            </section>


            <section className="main main_purpose xl:pt-[80px] pt-[60px] bg-no-repeat bg-center relative z-[2]" style={{ backgroundImage: `url(${blue_ring})`, backgroundPosition: "center top", backgroundSize: "1038px" }}>
                <div className='container max-w-[1380px] mx-auto px-[15px]'>

                    <h2 className="xl:mb-[70px] mb-[40px] font-osw xl:text-[90px] xl:leading-[80px] lg:text-[80px] lg:leading-[70px] md:text-[50px] md:leading-[40px] text-[40px] leading-[30px] text-[#5E5E5E] text-center">DESTINY <span className="font-light">TRAINING</span></h2>
                    <div className="main-wraper">
                        <div className="bg-[#f2f4fae8] video-warper shadow-[3px_3px_16px_#00000045] xl:p-[90px_90px] lg:p-[60px_60px] p-[20px_20px]">
                            <div className="inner max-w-[1220px] mx-auto">
                                <div className="w-full relative comon_video">
                                    <img src={purpose_coverup} alt="purpose_coverup" className='w-full h-full rounded-lg' />
                                    <img onClick={() => openPopup("Purpose")}
                                        className='absolute top-[50%] left-[50%] -translate-y-[50%] -translate-x-[50%] cursor-pointer w-[88px] h-[88px]' src={mainplay} alt="" />
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </section>

            <section className='main_purpose pt-[168px] bg-no-repeat bg-center -mt-[90px] relative z-[3] lg:pb-[110px] md:pb-[50px] pb-[0px] ring_gold ' style={{ backgroundImage: `url(${ring_gold})`, backgroundPosition: "center top", backgroundSize: "1590px" }}>
                <div className='container max-w-[1380px] mx-auto px-[15px]'>
                    <div className="main-wraper">
                        <div className="bg-[#f2f4fae8] shadow-[3px_3px_16px_#00000029] xl:p-[63px_76px] lg:p-[50px_30px] p-[40px_20px] max-w-[1261px] mx-auto">
                            <div className="inner">
                                <h3 className='lg:text-[40px] lg:leading-[55px] mg:text-[35px] md:leading-[45px] text-[30px] leading-[35px]  text-center'>PARTNERING IN DESTINY</h3>
                                <div className="mt-[23px] mb-[30px] img-wraper md:flex-row  flex justify-between items-center max-w-[638px] gap-[15px] mx-auto flex-col">

                                    <img className='max-w-[258px] w-full h-auto flex' src={footerlogo} alt="footerlogo" />
                                    <img className='max-w-[235px] w-full h-auto flex' src={DestinyInstitue} alt="DestinyInstitue" />
                                </div>
                                <p className='xl:text-[30px] xl:leading-[40px] lg:text-[25px] lg:leading-[35px] text-[18px] leading-[28px] text-[#000] text-center'>Provizion has partnered with <b className='font-semibold'>The Destiny Institute</b> to help you find and fulfill your specific Purpose and the amazing Destiny it will create for you. They have agreed to supply our new Wholesale Affiliates with major portions of their two leading courses, as FREE samples, plus they also offer a 60% discount on their Kingdom Purpose Blueprint video course and a 25% discount on their Master Keys self study course.</p>

                                <div className="last flex md:flex-row flex-col md:justify-between items-center lg:gap-[40px] gap-[20px] p-[40px_0_0]">
                                    <div className="left max-w-[520px]">
                                        <div className="pro">
                                            <img className='mx-auto mb-[30px]' src={Kindle} alt="Kindle" />
                                            <div className="inro text-center">
                                                <h4 className='text-[20px] leading-[27px] text-black font-semibold'> KINGDOM PURPOSE BLUEPRINT</h4>
                                                <p>Video Course</p>
                                                <p>by Dr. Bill Greenman</p>

                                                <div className="pera mt-[30px]">
                                                    <p className='text-[18px] leading-[30px] text-black'>The first three lessons of this faith-based 21 video course are complete with outlines and activity pages to jump start your discovery of what makes you YOU.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="right max-w-[500px]">
                                        <div className="pro">
                                            <img className='mx-auto mb-[10px]' src={MstrKeys} alt="Kindle" />
                                            <div className="inro text-center">
                                                <h4 className='text-[20px] leading-[27px] text-black font-semibold'> MASTER KEYS OF LIFE</h4>
                                                <p>Study Course</p>
                                                <p>by Dr. Bill Greenman</p>
                                                <div className="pera mt-[30px]">
                                                    <p className='text-[18px] leading-[30px] text-black'>Spring-boarding from their video course, The Destiny Institute created this standard course with extensive lessons in its Master Keys Book and Life Planner on the very same topics.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className="btn-wrapper xl:flex xl:gap-[100px] xl:mt-[73px] lg:gap-[50px] lg:mt-[50px] gap-[20px] mt-[30px]  md:flex-nowrap flex-wrap lg:w-[50%] w-[100%] lg:justify-end justify-center relative top-[140px] hidden">
                            {/* <button onClick={handlePdf} className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]">COMMISSION PLAN OVERVIEW</button> */}
                            <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029] z-[99]" onClick={() => window.open(`/api/Files/documents/FAQs_Products.pdf`, '_blank')}>FREQUENTLY ASKED QUESTIONS</button>
                        </div>
                    </div>
                </div>
            </section>


            {/* <section className='pt-[0px] relative z-[2] xl:-mt-[350px] -mt-[280px]'>
                <div className='container max-w-[1490px] mx-auto px-[15px]'>


                </div>
                <div className='img'>
                    <img className="mx-auto relative top-[0px]" src={rebon} alt="king" />
                </div>
            </section>

            <section className='p-[130px_0_44px] bg-no-repeat bg-center bg-cover relative -mt-[100px] z-[1]' style={{ backgroundImage: `url(${WilliamImge2})`, backgroundSize: "1530px", backgroundPosition: "center top" }}>
                <div className='overlay absolute top-[90px] left-0 w-full h-[calc(100%-90px)] bg-[#F6F7FB] opacity-[0.57] z-[1]'></div>
                <div className='container max-w-[1380px] mx-auto px-[15px] relative z-[2]'>

                    <div className="title">
                        <h2 className="font-osw text-[#000000] xl:text-[70px] lg:text-[60px] md:text-[50px] text-[30px] font-normal text-center font-osw xl:leading-[104px] lg:leading-[70x] mg:leading-[60x] leading-[40x]">YOUR LEGACY IS WAITING FOR YOU</h2>
                        <h3 className='xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[30px] text-[28px] leading-[38px] text-[#000000] text-center md:mt-[27px] mt-[18px] md:mb-[25px] mb-[18px]'>And We’ll Help Create It </h3>
                        <h3 className='xl:mb-[37px] mb-[25px] xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[30px] text-[28px] leading-[38px] text-[#000000] text-center'>INSTANT ACCESS</h3>
                    </div>

                    <div className="form">
                        <PowerlineForm />
                    </div>
                    <p className='xl:text-[24px] xl:leading-[30px] md:text-[20px] md:leading-[26px] text-[18px] leading-[24px] mx-auto xl:pt-[46px] pt-[30px] text-center text-[#000] max-w-[1100px]'>When you click the gold Instant Access button above we will immediately email your digital copy of Dr. Greenman’s highly acclaimed book, Absolute Certainty.</p>
                </div>
            </section> */}
            <section className='xl:pt-[100px] lg:pt-[60px] pt-[0px] relative z-[2]'>
                <div className='container mx-auto chosse-legecy-section flex xl:pt-[40px] lg:pt-[0px] pt-[40px] z-[3] relative lg:flex-nowrap flex-wrap px-[15px]'>
                    <div className="choose-legacy-heading lg:w-[50%] w-full xl:mt-[-110px]  mt-0">
                        <div className='lg:max-w-[500px] max-w-[100%] ml-auto mr-0'>
                            <div className="btn-wrapper flex w-[100%] justify-center xl:hidden mb-[15px]">
                                {/* <button onClick={handlePdf} className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]">COMMISSION PLAN OVERVIEW</button> */}
                                <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029] z-[99]" onClick={() => window.open(`/api/Files/documents/FAQs_Products.pdf`, '_blank')}>FREQUENTLY ASKED QUESTIONS</button>
                            </div>
                            <h2 className="text-center pr-0 lg:mb-0 mb-[15px] font-osw xl:text-[50px] xl:leading-[90px] lg:text-[40px] lg:leading-[50px] md:text-[35px] md:leading-[40px] text-[30px] leading-[40px]">
                                TIME IS OF THE ESSENCE
                            </h2>
                            <p className="text-center pb-[20px] text-[22px] font-osw">
                                Secure a position in our LegacyLine before other Visitors presently taking the website tour and enjoy the maximum benefits of all we offer.
                            </p>
                        </div>
                    </div>
                    <div className='visitors-section lg:pt-[0px] lg:pl-[15px] lg:w-[50%] w-full'>
                        <div className='w-full lg:max-w-[515px] max-w-full ml-auto mr-0'>
                            <VisitorList />
                        </div>
                    </div>
                </div>
                <div className="btn-wrapper flex justify-center xl:gap-[100px] xl:mt-[73px] lg:gap-[50px] lg:mt-[50px] gap-[20px] mt-[30px]  md:flex-nowrap flex-wrap">
                    <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]" onClick={() => window.open(`/api/Files/documents/LegcyLine_Overview_text.pdf`, '_blank')}>LEGACYLINE OVERVIEW</button>
                </div>
                <div className='img 2xl:z-[2] z-[1] relative'>
                    <img className="mx-auto relative 2xl:-top-[715px] xl:-top-[620px] -top-[0px]" src={rebon} alt="king" />
                </div>
            </section>

            <section className='lg:p-[130px_0_137px] p-[100px_0_50px]  bg-no-repeat bg-center bg-cover relative xl:-mt-[500px] lg:-mt-[100px] -mt-[80px] z-[99]' style={{ backgroundImage: `url(${WilliamImge2})`, backgroundSize: "1530px", backgroundPosition: "center top" }}>
                <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 xl:gap-8 gap-3 px-[15px]">

                    <div className="border p-6 bg-white flex flex-col items-center">
                        {/* <div className="btn-wrapper flex justify-center xl:gap-[100px] xl:mt-[73px] lg:gap-[50px] lg:mt-[50px] gap-[20px] mt-[30px]  md:flex-nowrap flex-wrap">
                                                    <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]">LEGACY OVERVIEW</button>
                                     </div>
                                     <div className="btn-wrapper flex justify-center xl:gap-[100px] lg:gap-[50px] gap-[20px] md:flex-nowrap flex-wrap">
                                                    <button className="bg-[#0071BA] tex-white xl:text-[24px] xl:leading-[55px] md:text-[20px] md:leading-[40px] text-[18px] leading-[30px] font-normal p-[8px_15px] max-w-[470px] w-full text-[#fff] uppercase transition delay-150 duration-300 ease-in-out hover:bg-black shadow-[3px_3px_8px_#00000029]">LEGACY OVERVIEW</button>
                                     </div> */}
                        <div className='md:max-w-[450px] max-w-full w-full mx-auto'>
                            <button className="bg-[#0071BA] text-white w-full text-center py-3 font-semibold text-lg mb-4" onClick={() => window.location.href = `/${storeAssigned()}/retail_signup`}>
                                BECOME A RETAIL CUSTOMER
                            </button>
                            <img src="/Images/retailcustomer.jpg" alt="Retail Customer" className="mb-4" />
                            <ul className="list-disc pl-5 text-black space-y-2 text-sm font-semibold">
                                <li className="font-semibold">Purchase Provizion products whenever you wish, from your store within this website</li>
                                <li>Access to Purpose International’s samples, discounted materials, and courses.</li>
                                <li>Access to samples and discounts on Dr. Greenman’s desk reference book on Glutathione.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="border p-6 bg-white flex flex-col items-center">
                        <div className='md:max-w-[450px] max-w-full w-full mx-auto'>
                            <button className="bg-[#0071BA] text-white w-full text-center py-3 font-semibold text-lg mb-4" onClick={() => window.location.href = `/${storeAssigned()}/business_owner`}>
                                BECOME A WHOLESALE AFFILIATE
                            </button>
                            <img src="/Images/wholesale.jpg" alt="Wholesale Affiliate" className="mb-4" />
                            <ul className="list-disc pl-5 text-black space-y-2 text-sm font-semibold">
                                <li>New Affiliates who were sponsored by Affiliates above you will be placed into your LegacyLine Team.</li>
                                <li>Sponsor New Affiliates and Retail Customers of your own.</li>
                                <li>Purchase Provizion products when you wish, from the back-office area of your Affiliate website.</li>
                                <li>Sell products to anyone at Retail pricing and keep the profit.</li>
                                <li>Receive Commissions, Bonuses, and Rewards.</li>
                                <li>Access to all Affiliate personal and business training materials.</li>
                            </ul>
                        </div>
                    </div>
                </div>


                {/* <div className='overlay absolute top-[90px] left-0 w-full h-[calc(100%-150px)] bg-[#F6F7FB] opacity-[0.57] z-[1]'></div>
                                        <div className='container xl:max-w-[1380px] mx-auto px-[15px] relative z-[2]'>
                                            <div className="title">
                                                <h2 className="font-osw text-[#000000] xl:text-[70px] lg:text-[60px] md:text-[50px] text-[30px] font-normal text-center font-osw xl:leading-[104px] lg:leading-[70x] mg:leading-[60x] leading-[40x]">YOUR LEGACY IS WAITING FOR YOU</h2>
                                                <h3 className='xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[30px] text-[28px] leading-[38px] text-[#000000] text-center md:mt-[27px] mt-[18px] md:mb-[25px] mb-[18px]     '>And We’ll Help Create It </h3>
                                                <h3 className='xl:mb-[37px] mb-[25px] xl:text-[50px] xl:leading-[60px] lg:text-[40px] lg:leading-[30px] text-[28px] leading-[38px] text-[#000000] text-center'>INSTANT ACCESS</h3>
                                            </div>
                        
                                            <div className="form">
                                                <PowerlineForm />
                                            </div>
                                            <p className=
                                            
                                            'xl:text-[24px] lg:text-[20px] text-[18px] mx-auto pt-[46px] text-center leading-[30px] text-[#000] max-w-[640px]'>We will immediately email your digital copy of Dr. Greenman’s highly acclaimed book, <b className='italic'>Absolute Certainty.</b></p>
                                        </div> */}


                <div className="bg-[#f3f4f6f2] container max-w-6xl mx-auto mt-[40px]">
                    <div className="xl:p-[40px] md:p-[20px] p-[25px_15px]">
                        <h2 className="font-osw xl:text-[40px] lg:text-[35px] text-[30px] leading-[1.2] text-center xl:mb-12 mb-4">
                            AFFILIATE AMENITIES
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">

                            <div>
                                <ul className="text-black text-lg">
                                    {[
                                        { title: "LegacyLine", desc: "position and invitation link" },
                                        { title: "Quality of Life", desc: "chart for tracking health/longevity" },
                                        { title: "Personal Affiliate", desc: "website" },
                                    ].map((item, index) => (
                                        <li key={index} className="flex items-start gap-3">
                                            <i className="fa fa-check text-yellow-500 text-2xl mt-1" aria-hidden="true"></i>
                                            <span>
                                                <strong>{item.title}</strong> {item.desc}
                                            </span>
                                        </li>
                                    ))}

                                    <li className="flex items-start gap-3">
                                        <i className="fa fa-check text-yellow-500 text-2xl mt-1" aria-hidden="true"></i>
                                        <div>
                                            <strong>TeamProvizion.com</strong>
                                            <ul className="list-disc pl-6 mt-2 text-base space-y-1">
                                                <li>Personal Purpose Materials</li>
                                                <li>LegacyLine Training</li>
                                                <li><strong>Media Library</strong> of approved marketing tools</li>
                                                <li>Graphics</li>
                                                <li>Product fliers</li>
                                                <li>Videos</li>
                                                <li>Pop up banners</li>
                                                <li>and More!</li>
                                            </ul>
                                        </div>
                                    </li>

                                    {[
                                        { title: "Access", desc: "Your Kingdom Purpose Blueprint - Module 1: our faith-based video series" },
                                        { title: "Access chapters 1-4 of", desc: "Master Keys Of Life: our standard life course materials" },
                                        { title: "Access 70 pages of", desc: "Glutathione: King of The Master: Molecules of Health, Dr. Bill Greenman's book" },
                                        { title: "Access", desc: "The Legacy Podcast – weekly interviews, product and business building insights" },
                                    ].map((item, index) => (
                                        <li key={`access-${index}`} className="flex items-start gap-3">
                                            <i className="fa fa-check text-yellow-500 text-2xl mt-1" aria-hidden="true"></i>
                                            <span>
                                                {item.title} <strong>{item.desc}</strong>
                                            </span>
                                        </li>
                                    ))}

                                </ul>
                            </div>

                            <div className="flex justify-center relative">
                                <div className="flex flex-col items-center space-y-6">
                                    <img
                                        src="/Images/books.png"
                                        alt="Blueprint"
                                        className="w-100"
                                    />

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            {isPopupOpen && (
                <div className="video-popup-overlay">
                    <div className="video-popup-content">
                        <button className="close-button" onClick={() => setIsPopupOpen(false)}>
                            &times;
                        </button>
                        <iframe
                            src={currentVideo}
                            ref={iframeRef}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Embedded Video"
                            className="video-iframe"
                        ></iframe>
                    </div>
                </div>
            )}
        </>
    )
}

export default Purposee